import { render } from "./MainSlot.vue?vue&type=template&id=1ee447d8&scoped=true"
import script from "./MainSlot.vue?vue&type=script&lang=js"
export * from "./MainSlot.vue?vue&type=script&lang=js"

import "./MainSlot.vue?vue&type=style&index=0&id=1ee447d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee447d8"]])

export default __exports__